import VueCookies from 'vue-cookies'

export const state = {
  accessTokenExpDate: getState("auth.accessTokenExpDate"),
  currentUser: getState("auth.currentUser"),
  //currentLocation: getCookie("LID"),
  currentLocation: getState('LID'),
  menuItems: getState("menu"),
};

export const mutations = {
  SET_ATOKEN_EXP_DATE(state, expDate) {
    state.accessTokenExpDate = expDate;
    saveState("auth.accessTokenExpDate", expDate);
  },
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    saveState("auth.currentUser", newValue);
  },
  SET_CURRENT_MERCHANT(state, newValue) {
    state.currentUser = newValue;
    saveState("auth.currentMerchant", newValue);
  },
  SET_CURRENT_LOCATION(state, value) {
    state.currentLocation = value;
    saveState("LID", value);
    saveCookie("LID", value);
    removeLocalStorage('dataPermission')
    removeLocalStorage('ORDER')
    removeLocalStorage('ORDER_ID')
  },
  SET_MENU(state, value) {
    state.menuItems = value;
    // saveState("menu", value);
  },
  SET_lIST_LOCATIONS(state, value) {
    saveState("auth.locations", value);
  }
};

export const actions = {
  setCurrentLocation({ commit }, id) {
    commit("SET_CURRENT_LOCATION", id);
  }
};

export const getters = {
  loggedIn(state) {
    return !!state.currentUser;
  }
};

// ===
// Private helpers
// ===

function getState(key) {
  const result = JSON.parse(window.localStorage.getItem(key))
  if(result == null || result == undefined) return ""
  return result;
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}

function getCookie(key) {
  return VueCookies.isKey(key)?VueCookies.get(key):null;
}

function saveCookie(key, state) {
  VueCookies.set(key,state)
}
function removeLocalStorage(key) {
  localStorage.removeItem(key)
}
